// extracted by mini-css-extract-plugin
export var actionButton = "_58-1";
export var actionButtons = "_58-2";
export var actions = "_58-0";
export var aiUnread = "_58-10";
export var alignCenter = "_58-h";
export var backWrapper = "_58-3";
export var cellContainer = "_58-4";
export var checkboxContainer = "_58-5";
export var contentContainer = "_58-6";
export var contentHeader = "_58-8";
export var conversationsTableWrapper = "_58-s";
export var draftReplyBadgeContainer = "_58-m";
export var dropdownItem = "_58-b";
export var dropdownItemsContainer = "_58-a";
export var dropdownTitle = "_58-c";
export var errorIcon = "_58-7";
export var filter = "_58-d";
export var gray = "_58-i";
export var headerActionButtons = "_58-e";
export var headerCheckboxContainer = "_58-f";
export var icon = "_58-j";
export var menuContainer = "_58-k";
export var noMoreTicketsIcon = "_58-12";
export var noMoreTicketsSubText = "_58-13";
export var oneLine = "_58-l";
export var optionsButton = "_58-n";
export var plus = "_58-o";
export var portalButtonsWrapper = "_58-g";
export var red = "_58-p";
export var scrolledTop = "_58-9";
export var search = "_58-q";
export var selectedConversationsCount = "_58-r";
export var spinner = "_58-t";
export var strong = "_58-u";
export var summaryCell = "_58-v";
export var tableContainer = "_58-11";
export var tagContainer = "_58-w";
export var threeDots = "_58-x";
export var twoLines = "_58-y";
export var unread = "_58-z";